import { createFileRoute, linkOptions } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'

import NotFoundResource from '@/components/router/not-found-resource'
import RouteSheet from '@/components/sheets/route-sheet'

const params = z.object({
  coverageUuid: z.string(),
})

export const Route = createFileRoute(
  '/app/data/companies/$uuid/(mainPage)/debtor/coverages/$coverageUuid',
)({
  component: RouteComponent,
  params,
  errorComponent: (props) => {
    const { t } = useTranslation()

    return (
      <NotFoundResource
        {...props}
        resourceType={t('resource-not-found.not-found.coverage.resource-type')}
        backTo={t(
          'resource-not-found.not-found.coverage.back-to-coverages-list',
        )}
        backToLink={closeLink}
      />
    )
  },
})

const closeLink = linkOptions({
  from: Route.fullPath,
  to: '..',
})

function RouteComponent() {
  return <RouteSheet closeLink={closeLink} />
}
